// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore } from "@firebase/firestore";
import * as url from "./utils/urls";
import { apiReq } from "./utils/makeRequest";

const firebaseConfig = {
  apiKey: "AIzaSyCqy0ukveMuCxfMLqp8HFzB2vAKmHMOKKY",
  authDomain: "hasfinder.firebaseapp.com",
  projectId: "hasfinder",
  storageBucket: "hasfinder.appspot.com",
  messagingSenderId: "1010901904635",
  appId: "1:1010901904635:web:ca94a04a9dfe53a58e145e",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const provider = new GoogleAuthProvider();

export const signInWithGoogle = () => {
  signInWithPopup(auth, provider)
    .then((result) => {
      const { user } = result;
      apiReq(
        url.GOOGLE_LOGIN,
        {
          token: user.accessToken,
          email_verified: user.emailVerified,
          name: user.displayName,
          email: user.email,
        },
        "post",
        {}
      )
        .then((res) => {
          if (res.success) {
            const userData = {
              status: true,
              token: res.data.token,
              userInfo: res.data,
            };
            // console.log("userData>>>", userData);
            localStorage.setItem("hashUser", JSON.stringify(userData));
            window.location.reload();
          }
        })
        .catch((error) => {
          console.log(error.message);
        });
      console.log("userinfo", user);
    })
    .catch((error) => {
      console.log(error);
    });
};

export const db = getFirestore(app);
